import { render } from "./SubSlider.vue?vue&type=template&id=dfb3a682"
import script from "./SubSlider.vue?vue&type=script&lang=js"
export * from "./SubSlider.vue?vue&type=script&lang=js"

import "./SubSlider.vue?vue&type=style&index=0&id=dfb3a682&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__